/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Callback_Open_AppInputs */

const en_common_auth_callback_open_app = /** @type {(inputs: Common_Auth_Callback_Open_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the app`)
};

const zh_common_auth_callback_open_app = /** @type {(inputs: Common_Auth_Callback_Open_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开应用`)
};

/**
* | output |
* | --- |
* | "Open the app" |
*
* @param {Common_Auth_Callback_Open_AppInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_callback_open_app = /** @type {((inputs?: Common_Auth_Callback_Open_AppInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Callback_Open_AppInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_callback_open_app(inputs)
	return zh_common_auth_callback_open_app(inputs)
});
export { common_auth_callback_open_app as "common.auth.callback.open_app" }